<script>
import { merchantComputed, setComputed } from '@state/helpers'

import Clipboard from 'clipboard'

export default {
  data() {
    return {
      hostname: `${location.protocol}//${window.location.hostname}`,
      copyBtn: null, // 存储初始化复制按钮事件
    }
  },
  computed: {
    ...merchantComputed,
    ...setComputed,
  },
  mounted() {
    setTimeout(() => {
      this.copyBtn = new Clipboard(this.$refs.copyButton, {
        text: function(trigger) {
          return trigger.getAttribute('aria-label')
        },
      });
      this.copyToClipboard()
    }, 100)
  },
  methods: {
    copyToClipboard() {
      const clipboard = this.copyBtn;
      // 成功回调
      clipboard.on('success', () => {
        this.$toast.open('複製成功');
        this.$emit('close');
      });
      // 失败回调
      clipboard.on('error', () => {
        this.$toast.open({
          type: 'is-danger',
          message: this.$t('global.COPY_SUCCESS' /* 複製成功 */),
        });
        this.$emit('close');
      })
    },
    onClose() {
      this.$emit('close')
    }
  },
}
</script>
<template>
  <div :class="$style['modal-wrapper']" style="width: auto">
    <header class="modal-card-head">
      <p
        class="modal-card-title"
      >{{$t('global.LIGHT_BOX_SHARE_TITLE', { merchantName: currentMerchant.name })/*分享{merchantName}網站*/}}</p>
      <div :class="$style['modalClose']" class="delete" @click="onClose"></div>
    </header>
    <section class="modal-card-body">
      <div class="columns has-text-centered">
        <div class="column">
          <a
            target="_blank"
            :href="`https://social-plugins.line.me/lineit/share?url=&text=${hostname}/${currentMerchant.alias}&from=line_scheme`"
            :class="$style['shar-icon']"
            class="button is-circle"
          >
            <BaseIcon icon-style="fab" name="line" />
          </a>
          <div>Line</div>
        </div>

        <div class="column">
          <a
            target="_blank"
            :href="`http://www.facebook.com/sharer/sharer.php?u=${hostname}/${currentMerchant.alias}`"
            :class="$style['shar-icon']"
            class="button is-circle"
          >
            <BaseIcon icon-style="fab" name="facebook" />
          </a>
          <div>Facebook</div>
        </div>
        <div class="column">
          <button
            ref="copyButton"
            type="button"
            :aria-label="`${hostname}/${currentMerchant.alias}`"
            :class="$style['shar-icon']"
            class="button is-circle"
          >
            <BaseIcon name="copy" />
          </button>
          <div>{{ $t('global.COPY_LINK') }}</div>
        </div>
      </div>
    </section>
  </div>
</template>
<style lang="scss" module>
  .modal-wrapper {
    display: flex;
    flex-direction: column;
    max-height: 90vh;
    text-align: center;
    background: white;
    border-radius: $size-section-border-radius;
  }

  .modalClose {
    background-color: transparent;
    &:hover {
      background-color: transparent;
    }

    &::before,
    &::after {
      background-color: $grey;
    }

    &::after {
      height: 100%;
    }

    &::before {
      width: 100%;
    }
  }
</style>
